/**
 * @author vishwadeep.kapoor
 * @Date: 2020-10-06 17:03:58
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-10-27 10:54:11
 */
import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { Box, Flex } from 'grid-styled';
import { Button } from 'antd';
import { Input } from '../../../components';
import { AppWrappperHOC } from '../../Root/HOC';
import ProfileNavigation from '../ProfileNavigation';
import { StyledProfile } from '../index';
import Container from '../../../components/Container';
import Loader from '../../../components/Loader';
import { ActivateAccountProps, ActivateAccountMapDispatchToProps, ActivateAccountMapStateToProps } from '../profileDataHandler';
import { constants, utils } from '../../../devUtils';

class ActivateAccount extends PureComponent {
  constructor() {
    super();
    this.state = { kit_number: '', validation_number: '' };
    this.renderScreenUI = this.renderScreenUI.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { CardActivate, CardActivate: { status } } = nextProps;
    const { CardActivate: _CardActivate, history } = this.props;
    if (!utils.isEqual(CardActivate, _CardActivate) && status) {
      utils.forceRedirect(history, { pathname: `${constants.LINK_ZAGGLE_CARD_DEAILS}/physical` });
    }
  }

  renderScreenUI() {
    const { onPhysicalCardActivate, isLoading, history } = this.props;
    const { kit_number, validation_number } = this.state;
    return (
      <Fragment>
        <h1 className="font-20 nomargin-left">Activate Physical Card</h1>
        <span>Please enter your kit and validation number (last 4 digits of card number) to activate your physical card</span><br /><br />
        <Input style={{ width: '40%' }} placeholder="kit number" onChange={(({ target }) => this.setState({ kit_number: target.value }))} /><br /><br />
        <Input
          style={{ width: '40%' }}
          placeholder="Validation Number (Last 4 digits of the card number)"
          onChange={(({ target }) => this.setState({ validation_number: target.value }))}
        /><br /><br />
        <Button
          loading={isLoading}
          type="primary"
          style={{ marginLeft: '26%' }}
          onClick={() => onPhysicalCardActivate({ kit_number, validation_number }, { apiMethod: 'POST', history })}
          disabled={!((kit_number && validation_number))}
        >Submit
        </Button>
      </Fragment>);
  }

  render() {
    const {
      history,
      isLoading,
    } = this.props;
    if (isLoading) {
      return <Loader />;
    }
    return (
      <StyledProfile>
        <Container>
          <br clear="all" />
          <Flex flexWrap="wrap" className="margin-t-3">
            <Box width={[12 / 12, 5 / 24]} pl={10}>
              <ProfileNavigation history={history} />
            </Box>
            <Box width={[12 / 12, 19 / 24]} pr={10}>
              <div className="Card_account_creation">
                <Flex flexWrap="wrap">
                  <Box width={[12 / 12, 12 / 12]}>
                    {this.renderScreenUI()}
                  </Box>
                </Flex>
              </div>
            </Box>
          </Flex>
        </Container>
      </StyledProfile>);
  }
}

ActivateAccount.propTypes = ActivateAccountProps;

const component = connect(ActivateAccountMapStateToProps, ActivateAccountMapDispatchToProps)(AppWrappperHOC(ActivateAccount));
export { ActivateAccount };

export default component;



// WEBPACK FOOTER //
// client/containers/Profile/ActivateAccount/index.jsx